/** Textos da seção Planos dentro do app (não confundir com admin). */

export const PLANOS_APP_SECTION_SUBTITLE =
  'Valores de referência dos planos. A assinatura é feita na etapa de escolha de plano após o cadastro.';

export const PLANOS_APP_CURRENT_PLAN_PREFIX = 'Plano atual:';

export const PLANOS_APP_NO_ACTIVE_PLAN =
  'Você ainda não tem um plano vinculado. Para assinar, conclua a etapa de escolha de plano após o cadastro.';

/** Enquanto o perfil Firestore não foi carregado (evita “sem plano” falso). */
export const PLANOS_APP_USER_LOADING = 'Carregando seu perfil…';

export const PLANOS_APP_CURRENT_PLAN_UNKNOWN_NAME = 'Plano ativo';

/** Badge no card do plano atual (mesma ideia da escolha de plano, sem botão). */
export const PLANOS_APP_BADGE_CURRENT_PLAN = 'Seu plano';

/** Rodapé informativo abaixo dos cards (Minha conta / Planos). */
export const PLANOS_APP_INFO_FOOTER =
  'Para alterar seu plano, cancele o plano atual primeiro. Você mantém acesso até o fim do período já pago; o novo plano só será cobrado na data da renovação, depois que você concluir uma nova assinatura.';

/** Cancelamento ao fim do período agendado: nova assinatura só após encerrar o ciclo atual. */
export const PLANOS_APP_INFO_FOOTER_CANCEL_SCHEDULED =
  'Após o fim do período já pago, você poderá assinar de novo pela etapa de escolha de plano ou quando essa opção estiver disponível no app.';

/**
 * Faixa de status no topo da seção Planos (cancelamento agendado — `subscription_cancel_at_period_end`).
 * @param planName Nome do plano ainda vinculado até o fim do período.
 */
export function planosAppCancelledHeadline(planName: string): string {
  return `Plano cancelado (${planName}). Nova assinatura só será possível quando o período atual terminar.`;
}
